import {FP_PRIVACY_POLICY_LINK} from '../../models/system.model';

const PrivacyPolicy = () => {
	return (
		<div className="text-center text-gray-500 mb-2 text-xs">
			Use is subject to <a href={FP_PRIVACY_POLICY_LINK} target="_blank" className="underline cursor-pointer">Terms of Service</a>
		</div>
	);
};

export default PrivacyPolicy;
